import apiClient from "../../http";
import {
  CATEGORY_LIST_REQUEST,
  CATEGORY_LIST_RESET,
  CATEGORY_LIST_SUCCESS,
  CATEGORY_LIST_FAIL,
  CATEGORY_DELETE_REQUEST,
  CATEGORY_DELETE_SUCCESS,
  CATEGORY_DELETE_FAIL,
  CATEGORY_CREATE_REQUEST,
  CATEGORY_CREATE_SUCCESS,
  CATEGORY_CREATE_FAIL,
  CATEGORY_CREATE_RESET,
  CATEGORY_EDIT_REQUEST,
  CATEGORY_EDIT_SUCCESS,
  CATEGORY_EDIT_FAIL,
  CATEGORY_EDIT_RESET,
  CATEGORY_UPDATE_REQUEST,
  CATEGORY_UPDATE_SUCCESS,
  CATEGORY_UPDATE_FAIL,
  CATEGORY_UPDATE_RESET,
} from "../Constants/CategoryConstants";
import { getCachedCategories, cacheCategories } from "../../utils/database";

// export const listCategories = () => async (dispatch) => {
//   return new Promise(async (resolve) => {
//     try {
//       dispatch({ type: CATEGORY_LIST_REQUEST });

//       const url = `/masterdata/MainCategory`;

//       const { data } = await apiClient.get(url);
//       console.log(data);

//       await dispatch({
//         type: CATEGORY_LIST_SUCCESS,
//         payload: {
//           items: data,
//         },
//       });
//       return resolve(data);
//     } catch (error) {
//       const message =
//         error.response && error.response.data.message
//           ? error.response.data.message
//           : error.message;
//       dispatch({
//         type: CATEGORY_LIST_FAIL,
//         payload: message,
//       });
//     }
//   });
// };

// DELETE Category

export const listCategories = () => async (dispatch) => {
  return new Promise(async (resolve) => {
    try {
      dispatch({ type: CATEGORY_LIST_REQUEST });

      // 1. Try to load from local IndexedDB cache
      const cached = await getCachedCategories();
      if (cached) {
        console.log("Fetch categories from local db.");
        dispatch({
          type: CATEGORY_LIST_SUCCESS,
          payload: { items: cached },
        });
        return resolve(cached);
      }

      console.log("Fetch categories from backend db.");
      // 2. If not cached or expired, fetch from backend
      const url = `/masterdata/MainCategory`;
      const { data } = await apiClient.get(url);

      // 3. Save in local IndexedDB
      await cacheCategories(data);

      dispatch({
        type: CATEGORY_LIST_SUCCESS,
        payload: { items: data },
      });

      return resolve(data);
    } catch (error) {
      const message = error.response?.data?.message || error.message;

      dispatch({
        type: CATEGORY_LIST_FAIL,
        payload: message,
      });
    }
  });
};

export const deleteCategory =
  (id, keyId = "null") =>
  async (dispatch) => {
    try {
      dispatch({ type: CATEGORY_DELETE_REQUEST });

      await apiClient.delete(`/record/Category/${id}/${keyId}`, {
        requiresAuth: true,
      });

      dispatch({ type: CATEGORY_DELETE_SUCCESS });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message || error;

      dispatch({
        type: CATEGORY_DELETE_FAIL,
        payload: message,
      });
    }
  };

// CREATE Category
export const createCategory = (obj) => async (dispatch) => {
  return new Promise(async (resolve) => {
    try {
      dispatch({ type: CATEGORY_CREATE_REQUEST });

      const { data } = await apiClient.post(`/record/Category`, obj, {
        requiresAuth: true,
      });

      console.log(data);
      dispatch({ type: CATEGORY_CREATE_SUCCESS, payload: data });

      return resolve(data);
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message || error;
      dispatch({
        type: CATEGORY_CREATE_FAIL,
        payload: message,
      });
    }
  });
};

// EDIT Category
export const editCategory =
  (id, keyId = "null") =>
  async (dispatch) => {
    return new Promise(async (resolve) => {
      try {
        dispatch({ type: CATEGORY_EDIT_REQUEST });

        const { data } = await apiClient.get(
          `/record/Category/${id}/${keyId}`,
          {
            requiresAuth: true,
          }
        );
        console.log(data);
        dispatch({
          type: CATEGORY_EDIT_SUCCESS,
          payload: {
            item: data.items[0],
          },
        });
        return resolve(data);
      } catch (error) {
        const message =
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message || error;
        dispatch({
          type: CATEGORY_EDIT_FAIL,
          payload: message,
        });
      }
    });
  };

// UPDATE Category
export const updateCategory =
  (id, obj, keyId = "null") =>
  async (dispatch) => {
    return new Promise(async (resolve) => {
      try {
        dispatch({ type: CATEGORY_UPDATE_REQUEST });

        const url = `record/Category/${id}/${keyId}`;

        const { data } = await apiClient.put(url, obj, {
          requiresAuth: true,
        });

        dispatch({ type: CATEGORY_UPDATE_SUCCESS, payload: data });
        return resolve(data);
      } catch (error) {
        const message =
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message || error;

        dispatch({
          type: CATEGORY_UPDATE_FAIL,
          payload: message,
        });
      }
    });
  };
